export default "<p>\r\n  modal-plan-cuentas works!\r\n</p>\r\n";